import { formatUSDShort } from "@/web/lib/formatting";
import { averageLastSalePriceFromComps } from "@/web/routes/_protected/smb/-dashboard/comps";
import type { Comp, Property } from "@tycho/web-bindings/types";
import type { PriceEstimateFeedback, ReviewComp } from "./types";

export function toUserPriceJudgement(feedback: PriceEstimateFeedback | null) {
  if (feedback === "Too High") return { tag: "High" as const };
  if (feedback === "Too Low") return { tag: "Low" as const };
  if (feedback === "Seems Right") return { tag: "Correct" as const };
  return undefined;
}

export function formatAutoTopCompsTitle(count: number): string {
  return count === 1 ? "Here is your top property" : `Here are your top ${count}`;
}

export function formatLocationLine(comp: Pick<Comp, "address">): string {
  return `${comp.address.city}, ${comp.address.state} ${comp.address.zip}`;
}

export function formatSqft(sqft: number | undefined): string {
  return sqft == null ? "-" : Math.round(sqft).toLocaleString();
}

export function formatLastSoldLabel(comp: Pick<Comp, "lastSalePrice" | "lastSaleDate">): string {
  const price =
    comp.lastSalePrice == null ? "?" : `$${(comp.lastSalePrice / 1_000_000).toFixed(2)}M`;
  const year = comp.lastSaleDate?.slice(0, 4) ?? "unknown";
  return `Last sold for ${price} in ${year}`;
}

export function formatAddressLine(address: Property["address"]): string {
  return address.addressLine1;
}

export function resolvePriceEstimate(property: Property, comps: ReviewComp[]): string {
  if (property.priceEstimate != null) return formatUSDShort(property.priceEstimate);

  const averagePrice = averageLastSalePriceFromComps(comps, property);
  if (averagePrice === undefined) return "Pending";
  return formatUSDShort(averagePrice);
}
